module.exports = __webpack_public_path__ + "static/img_1-9853a66ce984b91031e01041d55eded5.png";